/**
 * Font size of a medication number mark at the given pin scale (see
 * `pinScaleForImage`). Every surface that draws the number goes through this,
 * so it keeps the same size against the face in the editor, thumbnails, the
 * compare view and exports. At the default thickness it is about a pin badge.
 */
export const medicationNumberFontSize = (
  strokeWidth: number,
  scale: number,
): number => (4 + 2 * (strokeWidth || 1)) * scale;

/** Width of the white outline that keeps the number readable on skin. */
export const medicationNumberOutline = (fontSize: number): number =>
  fontSize / 8;
